module.exports = __webpack_public_path__ + "img/allow-blue-down.71f5b993.svg";